import { type AxiosResponse } from 'axios'

import { type CustomAxiosConfig } from '@/types/axios'
import { type AdmissionRoom } from '@/types/Room'

import armSecureAxios from './secure-base'

export const fetchAllAdmissionRooms = async (config?: CustomAxiosConfig): Promise<AxiosResponse<AdmissionRoom[]>> => {
  return await armSecureAxios.get('/rooms/all', { ...config })
}

const roomArmService = {
  fetchAllAdmissionRooms
}

export default roomArmService
